import { useEffect, useRef, useState } from "react";
import "./AccountMenu.css";

const config = window.TAYTANIUM_CONFIG || {};

function initialOf(account) {
  return (account.display_name || account.username || "?").charAt(0).toUpperCase();
}

export default function AccountMenu() {
  const [account, setAccount] = useState(undefined);
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    fetch(`${config.accountApi}/api/v1/me`, { credentials: "include" })
      .then((response) => (response.ok ? response.json() : null))
      .catch(() => null)
      .then(setAccount);
  }, []);

  useEffect(() => {
    if (!open) return undefined;

    function handlePointer(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) setOpen(false);
    }

    document.addEventListener("mousedown", handlePointer);
    return () => document.removeEventListener("mousedown", handlePointer);
  }, [open]);

  if (account === undefined) return <span className="account-menu-placeholder" aria-hidden="true" />;

  if (!account) {
    const next = encodeURIComponent(window.location.href);
    return (
      <div className="account-menu-signed-out">
        <a className="button button-secondary button-small" href={`${config.loginUrl}/register?next=${next}`}>
          Sign up
        </a>
        <a className="button button-primary button-small" href={`${config.loginUrl}/login?next=${next}`}>
          Log in
        </a>
      </div>
    );
  }

  async function signOut() {
    await fetch(`${config.loginApi}/api/v1/logout`, { method: "POST", credentials: "include" }).catch(() => null);
    window.location.reload();
  }

  return (
    <div className="account-menu" ref={menuRef}>
      <button
        type="button"
        className="account-menu-toggle"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        {account.avatar_url ? (
          <img className="account-menu-avatar" src={account.avatar_url} alt="" />
        ) : (
          <span className="account-menu-avatar account-menu-initial" aria-hidden="true">
            {initialOf(account)}
          </span>
        )}
        <span className="account-menu-name">{account.display_name || account.username}</span>
      </button>

      {open && (
        <div className="account-menu-panel" role="menu">
          <div className="account-menu-who">
            <strong>{account.display_name || account.username}</strong>
            <span>@{account.username}</span>
          </div>
          <a role="menuitem" href={config.accountUrl}>Manage account</a>
          <button type="button" role="menuitem" onClick={signOut}>Sign out</button>
        </div>
      )}
    </div>
  );
}
